<div *ngIf="pageModel$ | async as pageModel" class="pcg-search-page pcg-contrast__bg-alt">
    <div class="pcg-search-page__row container">
        <pcg-ng-saved-searches-bar [savedSearchesPageLink]="pageModel.properties.SavedSearchesPage" data-config="{}"></pcg-ng-saved-searches-bar>

        <a *ngIf="pageModel.properties.AddDirectoryItemLink" [link]="pageModel.properties.AddDirectoryItemLink"
           class="pcg-main-button pcg-search-page__add pcg-contrast__btn"
           pcg-ng-umbraco-link>
        </a>
    </div>
    <div class="pcg-content-grid container pcg-search-page__content">
        <div class="pcg-content-grid__aside">
            <pcg-ng-directory-search-filters
                #filtersRef
                (searchButtonClicked)="onSearchTriggered()"
                (skipToResults)="handleSkipToResults($event)"
                (toggleMapButtonClicked)="onToggleMap()"
                [datesSpan$]="datesSpan$"
                [distanceControl]="searchForm.distance"
                [isMapVisible]="isMapVisible"
                [postcodeControl]="searchForm.postcode"
                [searchConfig]="searchTabConfig"
                [searchForm]="searchForm">
            </pcg-ng-directory-search-filters>
        </div>
        <div #searchResults class="pcg-content-grid__main pcg-search-page__mainbar" id="search-results">
            <ng-container *ngIf="isLocked$ | async">
                <div class="pcg-backdrop"></div>
                <div class="pcg-spinner pcg-spinner--large"></div>
            </ng-container>

            <article *ngIf="this.searchTabConfig?.contentSearchPageUrl && contentSearchResult$ | async as contentSearchResult" class="pcg-info-block">
                <div class="pcg-info-block__header">
                    <h2 class="pcg-info-block__title">{{ pageModel.properties.InformationBlockTitle }}</h2>
                    <button aria-controls="collapsible-info-block-content"
                            aria-expanded="true"
                            aria-label="hide/show button"
                            class="pcg-info-block__button pcg-contrast__btn"
                            data-bs-target=".js-collapsible-info-block"
                            data-bs-toggle="collapse"
                            id="collapsible-info-block" type="button">
                    </button>
                </div>
                <div aria-labelledby="collapsible-info-block"
                     class="pcg-info-block__content-wrapper js-collapsible-info-block collapse show"
                     id="collapsible-info-block-content">
                    <div class="pcg-info-block__content">

                        <a *ngFor="let item of contentSearchResult.pageItems" class="pcg-info-block-item pcg-contrast__border-main" href="{{item.url}}">
                            <h3 class="pcg-info-block-item__title">{{ item.name }}</h3>
                            <p [innerHTML]="item.contentPreview" class="pcg-info-block-item__text pcg-contrast__color-main">
                            </p>
                        </a>

                        <a class="pcg-info-block__more pcg-contrast__btn" href="{{getContentResultPageUrl()}}">See all {{ contentSearchResult.totalItems }} information results</a>
                    </div>
                </div>
            </article>

            <h2 class="pcg-search-page__title">{{ pageModel.properties.DirectorySearchResultsTitle }}</h2>

            <ng-container *ngIf="searchResult$ | async as searchResultModel">
                <div class="pcg-search-toolbar">
                    <div *ngIf="!searchResultModel.pageItems?.length"
                         [innerHTML]="resolveNoResultsMessage(pageModel.properties.SearchNoResultsMessage?.markup)"
                         class="pcg-search-toolbar__no-results pcg-contrast__color-main"
                         role="status">
                    </div>

                    <div *ngIf="searchResultModel.pageItems?.length" class="pcg-search-toolbar__row">
                        <p class="pcg-search-toolbar__results pcg-contrast__color-main"
                           role="status">{{ searchResultModel.totalItems }} results found</p>

                        <div class="pcg-search-sorting pcg-contrast-search-sorting pcg-search-toolbar__sorting">
                            <label class="pcg-search-sorting__label" for="search-sorting">Sort by:</label>
                            <div class="pcg-search-sorting__wrapper">
                                <select [formControl]="searchForm.sortOption" class="pcg-search-sorting__select" id="search-sorting"
                                        name="">
                                    <option value="Rank;asc">Relevance</option>
                                    <option value="Occurrence,Name;asc">Date</option>
                                    <option value="Name;asc">A-Z</option>
                                    <option value="Name;desc">Z-A</option>
                                    <option value="Distance;asc">Distance</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="filtersRef.selectedDisplayTags.length > 0" class="pcg-search-toolbar__filters">
                        <div *ngFor="let tag of filtersRef.selectedDisplayTags"
                             class="pcg-search-tag pcg-contrast__bg-extra pcg-contrast__color-main">
                            <span class="pcg-search-tag__text">{{ tag.title }}</span>
                            <button (click)="filtersRef.removeTag(tag.value)"
                                    aria-label="remove filter item"
                                    class="pcg-search-tag__close pcg-contrast__link"
                                    type="button">
                            </button>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="searchResultModel.pageItems?.length">

                    <pcg-ng-pagination
                        (ngModelChange)="setPageNumber($event)"
                        [(ngModel)]="selectedPageNumber"
                        [options]="paginationOptions"
                        [pagination]="searchResultModel"
                        [parentSelector]="'pcg-search-page__pagination'"
                        class="pcg-search-page__pagination">
                    </pcg-ng-pagination>

                    <div *ngIf="_googleMapService.mapVisibility$ | async as mapVisibility"
                         [ngClass]="{'hidden': !mapVisibility.showMap}"
                         class="pcg-search-page__map">
                        <pcg-ng-google-map [searchResult$]="searchResult$" [viewPageUrl]="pageModel.properties.DetailsPage && pageModel.properties.DetailsPage.length ? pageModel.properties.DetailsPage[0].route.path : null"></pcg-ng-google-map>
                    </div>

                    <pcg-ng-directory-search-results-list-view
                        [defaultImageUrl]="pageModel.properties.SearchResultDefaultImage && pageModel.properties.SearchResultDefaultImage.length ? pageModel.properties.SearchResultDefaultImage[0].url : null"
                        [searchResult]="searchResultModel"
                        [viewPageUrl]="pageModel.properties.DetailsPage && pageModel.properties.DetailsPage.length ? pageModel.properties.DetailsPage[0].route.path : null">
                    </pcg-ng-directory-search-results-list-view>

                    <pcg-ng-pagination
                        (ngModelChange)="setPageNumber($event)"
                        [(ngModel)]="selectedPageNumber"
                        [options]="paginationOptions"
                        [pagination]="searchResultModel"
                        [parentSelector]="'pcg-search-page__pagination'"
                        class="pcg-search-page__pagination">
                    </pcg-ng-pagination>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
